import type { NuxtApp } from 'nuxt/app'

interface ToBreadcrumbUrlOptions {
  ctx?: NuxtApp
}

export function toBreadcrumbUrl(urlValue: string | undefined, { ctx }: ToBreadcrumbUrlOptions = {}) {
  const relative = (ctx
    ? ctx.runWithContext(() => getRelativeUrl(urlValue))
    : getRelativeUrl(urlValue))

  return typeof relative === 'string' ? relative : undefined
}
